import { ButtonBase, Card, makeStyles } from "@material-ui/core";
import React from "react";
import { COLORS } from "../../assets/theme";
import { CardBody } from "reactstrap";
import useTagButtonStyles from "../atoms/TagButton/useTagButtonStyles";
import { small } from "../../assets/breakpoints";
import { AVehicleWithColor } from "../../types/vehicle";
import { adjustDateByTime } from "../../assets/usefulFunctions";
import { IoIosWarning } from "react-icons/io";

type Props = {
  vehicleData: AVehicleWithColor;
};

const customCardStyle = makeStyles({
  root: {
    width: "100%",
    overflow: "hidden",
    border: "1px solid " + COLORS.gradientGray_1,
    borderRadius: "8px",
    display: "block",
    marginBottom: 16,
    background: COLORS.gradientGreen_4,
    padding: 8,
    "&.active": {
      background: COLORS.gradientGreen_4,
    },
    "&.inactive": {
      background: COLORS.gradientBlueRed,
    },
  },
  cardContainer: {
    border: "none",
    background: "transparent",
  },
  container: {
    display: "flex",
    background: COLORS.gradientGreen_4,
    "&.inactive": {
      background: COLORS.gray_1,
    },
    border: "1px solid " + COLORS.gradientGray_1,
    borderRadius: "8px",
    marginBottom: "16px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  cardBodyContainer: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    paddingRight: "20px",
    paddingLeft: "20px",
    textAlign: "left",
    "&.inactive": {
      background: COLORS.gray_1,
    },
  },
  vehicleText: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 700,
    width: "100%",
    color: COLORS.black_1,
    [small]: {
      width: 200,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
});

const VehicleCard: React.FunctionComponent<Props> = ({ vehicleData }) => {
  const tag_classes = useTagButtonStyles();
  const cardClasses = customCardStyle();
  const {
    color,
    internal_id,
    type,
    expiration_inspect_date,
    day_left,
    status,
    sub_type,
  } = vehicleData;
  return (
    <ButtonBase className={[cardClasses.root, status?.toLowerCase()].join(" ")}>
      <Card elevation={0} className={cardClasses.cardContainer}>
        <CardBody className={[cardClasses.cardBodyContainer].join(" ")}>
          <div style={{ width: "50%" }}>
            <p className={cardClasses.vehicleText}>{internal_id}</p>
            <div
              className={tag_classes.tag}
              style={{
                backgroundColor: color ? color : COLORS.green_1,
                color: COLORS.white,
                width: "fit-content",
              }}
            >
              {type} - {sub_type}
            </div>
          </div>
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              backgroundColor: "transparent",
              border: 0,
            }}
          >
            <div
              style={{
                color: COLORS.red_1,
                textAlign: "right",
                fontWeight: 700,
              }}
            >
              <p style={{ marginBottom: 2 }}>
                {expiration_inspect_date
                  ? adjustDateByTime(
                      expiration_inspect_date as string,
                      "dd-MM-yyyy"
                    )
                  : "Tidak ada Inspeksi terakhir"}
              </p>
              <p style={{ margin: 0 }}>({day_left ?? "-"} hari)</p>
              {day_left <= 0 ? (
                <div
                  className={tag_classes.tag}
                  style={{
                    backgroundColor: COLORS.red_1,
                    color: COLORS.white,
                    width: "fit-content",
                    marginTop: 2,
                    fontSize: 8,
                  }}
                >
                  Sudah lewat
                </div>
              ) : null}
            </div>
            <IoIosWarning
              size={20}
              style={{ marginLeft: 8 }}
              color={COLORS.red_1}
            />
          </div>
        </CardBody>
      </Card>
    </ButtonBase>
  );
};

export default VehicleCard;
